
import React from 'react';
import UniversitiesManagement from '@/components/admin/UniversitiesManagement';

const UniversitiesManagementPage = () => {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Universities Management</h1>
        <p className="text-muted-foreground">
          Manage universities and their information
        </p>
      </div>
      <UniversitiesManagement />
    </div>
  );
};

export default UniversitiesManagementPage;
